var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('config-field',{attrs:{"title":_vm.$t('pick_color'),"help-message":_vm.$t('pick_color_help_message')}},[_c('color-picker',{attrs:{"color":_vm.currentColor,"disabled":_vm.disabled},on:{"onAccept":_vm.handlePickerAccept}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }